import { meetingLink } from './links.js';
import { generatedDocumentsStatusValueLabels, meetingEventDocumentTypeValueLabels, meetingStatusValueLabels, } from './value-labels.js';
/** Documents attached to meetings: agendas, minutes, transcripts, public notices, and other materials. */
export const meetingEventDocumentsCube = {
    category: 'Documents',
    description: 'Documents attached to meetings including agendas, minutes, transcripts, and public notices.',
    label: 'Meeting Documents',
    measures: {
        'meeting_event_documents.count': { label: 'Count', type: 'number' },
    },
    dimensions: {
        'meeting_event_documents.name': { label: 'Document Name', type: 'string' },
        'meeting_event_documents.type': {
            label: 'Document Type',
            type: 'string',
            valueLabels: meetingEventDocumentTypeValueLabels,
        },
        'meeting_event_documents.status': {
            label: 'Status',
            type: 'string',
            valueLabels: generatedDocumentsStatusValueLabels,
        },
        'meeting_event_documents.security_level': { label: 'Security Level', type: 'string' },
        'meeting_event_documents.is_public': { label: 'Is Public', type: 'boolean' },
        'meeting_event_documents.has_attachment': { label: 'Has File', type: 'boolean' },
        'meetings.title': { label: 'Meeting Title', link: meetingLink, type: 'string' },
        'meetings.status': {
            label: 'Meeting Status',
            type: 'string',
            valueLabels: meetingStatusValueLabels,
        },
    },
    timeDimensions: {
        'meeting_event_documents.published_at': { label: 'Published At', type: 'date' },
        'meeting_event_documents.created_at': { label: 'Created At', type: 'date' },
        'meetings.date': { label: 'Meeting Date', type: 'date' },
    },
};
